import { render } from "./Menaces.vue?vue&type=template&id=97dee83e&scoped=true"
import script from "./Menaces.vue?vue&type=script&lang=js"
export * from "./Menaces.vue?vue&type=script&lang=js"

import "./Menaces.vue?vue&type=style&index=0&id=97dee83e&lang=scss&scoped=true"

import exportComponent from "/Users/khalid/Sites/sathoan/echosea/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97dee83e"]])

export default __exports__